import { useBusEmitterListener } from "../bridge";

const event = Symbol("bridge:editorHubConnectionStateChanged");

export const {
  emitter: editorHubConnectionStateChanged,
  listener: onEditorHubConnectionStateChanged,
} = useBusEmitterListener(event);
